module.exports = __webpack_public_path__ + "static/img/10.ea8b7f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/10.png
// module id = 5ux6
// module chunks = 0